import Account from 'modules/Services/Account/Account'
import Sagas from 'modules/Services/Account/store/saga'
import Reducer from 'modules/Services/Account/store/reducer'

export default Account

export { Sagas, Reducer }
